/**
 * CameraSettingsIcon — The camera with the cog of ServerSettingsIcon in its body, so the Camera
 * settings entry reads as the settings side of Cameras. Hugeicons video-02 and server-cog (MIT).
 */

import svg from './svg/camera-settings.svg?raw';
import { makeSvgIcon } from './svgIcon';

export const CameraSettingsIcon = makeSvgIcon('camera-settings', svg);
